import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import Button from '@base/Button/Button';
import H1 from '@base/H1/H1';
import P from '@base/P1/P1';
import SomethingWentWrongIcon from '@icon/SomethingWentWrong';

const Container = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height: 85vh;
  padding-left: ${Spacings.SPACING_4B};
  padding-right: ${Spacings.SPACING_4B};
`;
const Wrapper = styled.div`
  max-width: ${Spacings.APP_CONTAINER_WIDTH};
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  max-height: 248px;
`;
const Title = styled(H1)`
  font-size: ${Spacings.SPACING_6B};
  line-height: ${Spacings.SPACING_8B};
  margin-bottom: ${Spacings.SPACING_2B};
  margin-top: ${Spacings.SPACING_4B};
  text-align: center;
  width: 90%;
  ${mediaQuery.uptoMobile} {
    font-size: ${Spacings.SPACING_5B};
    line-height: ${Spacings.SPACING_7B};
    width: 90%;
  }
`;

const SubTitle = styled(P)`
  font-size: ${Spacings.SPACING_14};
  line-height: ${Spacings.SPACING_5B};
  margin-bottom: ${Spacings.SPACING_6B};
  text-align: 'center';
  width: 60%;
  background: 'red';
  ${mediaQuery.uptoMobile} {
    width: 90%;
  }
`;
const handleClick = () => {
  window.location.reload(false);
};
const SomethingWentWrong = () => {
  return (
    <Container>
      <Wrapper>
        <SomethingWentWrongIcon />
        <Title>Something went wrong</Title>
        <SubTitle>
          There was an issue connecting with the server. Please try again.
        </SubTitle>
        <Button label="Retry" color="black" onClick={handleClick} />
      </Wrapper>
    </Container>
  );
};
export default SomethingWentWrong;
